/**
 * @module converse-reactions
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 * @description
 * This plugin implements XEP-0444: Message Reactions UI
 * It allows users to react to messages with emojis.
 */
import './plugin.js';
import './emoji-picker-dropdown.js';
import './reaction-picker.js';
import './reactions.js';
